import { useNavigate } from "react-router-dom";
import { useCurrentUser } from "@/hooks/useCurrentUser";
import { Button } from "@/components/ui/button";

export default function LogoutButton() {
    const navigate = useNavigate();
    const { deleteCurrentUser } = useCurrentUser();

    const handleLogout = () => {
        deleteCurrentUser();
        navigate("/login");
    };
    return (
        <Button variant="outline" onClick={handleLogout}>
            Logout
        </Button>
    );
}
